import { createSelector } from 'reselect';
import { formatUserBoardCardsData } from '../../../utils/app.utils';
import { actions } from './actions';

const initialState = {
  userBoardData: [],
  isLoading: 0,
  userBoardCardData: {
    pendingObjectiveCreation: { userCount: 0, users: [] },
    pendingOwnerAcceptance: {
      userCount: 0,
      objectivesCount: 0,
      users: []
    },
    pendingManagerApproval: {
      userCount: 0,
      objectivesCount: 0,
      users: []
    },
    notCheckedin: {
      userCount: 0,
      objectivesCount: 0,
      users: []
    }
  }
};

export const getUserBoardCardDataSelector = createSelector(
  state => state.userBoardReducer.userBoardCardData,
  userBoardCardData => userBoardCardData
);

export const getTeamUsersDataSelector = createSelector(
  state => state.userBoardReducer.teamUsersData,
  teamUsersData => teamUsersData
);

export const getUserBoardDataSelector = createSelector(
  state => state.userBoardReducer.userBoardData,
  userBoardData => userBoardData
);

const UserboardReducer = (state = initialState, payload = {}) => {
  switch (payload.type) {
    case actions.INCREASE_LOADING_COUNT:
      return {
        ...state,
        isLoading: state.isLoading + 1
      };
    case actions.DECREASE_LOADING_COUNT:
      return {
        ...state,
        isLoading: state.isLoading - 1
      };
    case actions.SAVE_USERBOARD_DATA: {
      const formattedUserBoardCardData = formatUserBoardCardsData(payload.data);
      return {
        ...state,
        userBoardData: payload.data,
        userBoardCardData: formattedUserBoardCardData
      };
    }

    case actions.SAVE_TEAM_USERS_DATA:
      return {
        ...state,
        teamUsersData: payload.data
      };
    default:
      return {
        ...state
      };
  }
};

export default UserboardReducer;
